import {
    SettingType,
    FeatureType,
    ValidationMessage,
    ValidationMessageType,
} from '@appblocks/codegeneration/types';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';


/**
 * PeripheralWiring Feature
 *
 * Stores custom peripheral wiring layout data as a JSON string.
 * This allows users to define custom shapes, points, and labels
 * for visualizing peripheral connections on TPP boards.
 */
export default class PeripheralWiring extends BaseFeature {
    constructor() {
        super();
        this.name = 'Peripheral Wiring';
        this.id = 'peripheral_wiring';
        this.icon = 'FaProjectDiagram';
        this.priority = 10;
        this.singleInstance = true;
        this.featureType = FeatureType.FEATURE;
        this.requirements = [['TPP', 'tios']];
        this.description = 'Custom peripheral wiring layout for visualizing device connections';

        const settings = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.BOOLEAN,
                default: '1',
                helpText: 'Enable peripheral wiring visualization',
            },
            {
                id: 'LAYOUT_DATA',
                name: 'Layout Data',
                settingType: SettingType.STRING,
                default: '[]',
                helpText: 'JSON-stringified array of layout elements (shapes, points, labels)',
            },
            {
                id: 'CUSTOM_SHAPES',
                name: 'Custom Shapes',
                settingType: SettingType.STRING,
                default: '[]',
                helpText: 'JSON-stringified array of custom shape definitions',
            },
            {
                id: 'CUSTOM_GROUPS',
                name: 'Custom Groups',
                settingType: SettingType.STRING,
                default: '[]',
                helpText: 'JSON-stringified array of custom group definitions',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    /**
     * Get the layout elements as a parsed array
     * @returns Array of layout elements
     */
    getLayoutElements(): any[] {
        const layoutData = this.getSettingValue('LAYOUT_DATA');
        if (!layoutData || layoutData === '') {
            return [];
        }
        try {
            return JSON.parse(layoutData);
        } catch (e) {
            console.warn('Failed to parse peripheral wiring layout data:', e);
            return [];
        }
    }

    /**
     * Set the layout elements from an array
     * @param elements Array of layout elements to save
     */
    setLayoutElements(elements: any[]): void {
        const jsonString = JSON.stringify(elements);
        this.setSettingValue('LAYOUT_DATA', jsonString);
    }
}
